// {
//   "name": "iconic-animated-background-first.js",
//   "author": "Arham Web Works",
//   "description": "Copying in any form is strictly prohibited. Any instance of copying will be subject to legal action and accountability under the law."
// }

(() => {
  function parseHexColor(hex) {
    if (!hex || typeof hex !== 'string') return [0.1, 0.1, 0.18, 1.0];
    
    if (hex.toLowerCase() === 'transparent' || hex === 'rgba(0,0,0,0)' || hex === 'rgba(0, 0, 0, 0)') {
      return [0.0, 0.0, 0.0, 0.0];
    }

    hex = String(hex).replace(/^#/, '').trim();
    if (hex.length === 6) {
      var r = parseInt(hex.slice(0, 2), 16) / 255;
      var g = parseInt(hex.slice(2, 4), 16) / 255;
      var b = parseInt(hex.slice(4, 6), 16) / 255;
      return [r, g, b, 1.0];
    }
    if (hex.length === 8) {
      var r = parseInt(hex.slice(0, 2), 16) / 255;
      var g = parseInt(hex.slice(2, 4), 16) / 255;
      var b = parseInt(hex.slice(4, 6), 16) / 255;
      var a = parseInt(hex.slice(6, 8), 16) / 255;
      return [r, g, b, a];
    }
    return [0.1, 0.1, 0.18, 1.0];
  }

  function parseGradientToTwoColors(gradientCss) {
    if (!gradientCss || typeof gradientCss !== 'string') return null;
    var s = gradientCss.trim();
    if (s.indexOf('linear-gradient') === -1) return null;
    var hexMatch = s.match(/#[0-9A-Fa-f]{6}(?:[0-9A-Fa-f]{2})?/g);
    if (hexMatch && hexMatch.length >= 2) {
      return [parseHexColor(hexMatch[0]), parseHexColor(hexMatch[hexMatch.length - 1])];
    }
    var rgbaMatch = s.match(/rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*[\d.]+)?\s*\)/g);
    if (rgbaMatch && rgbaMatch.length >= 2) {
      var c1 = rgbaMatch[0].match(/(\d+)/g);
      var c2 = rgbaMatch[rgbaMatch.length - 1].match(/(\d+)/g);
      if (c1 && c2) {
        var a1 = c1.length >= 4 ? parseInt(c1[3], 10) / 255 : 1;
        var a2 = c2.length >= 4 ? parseInt(c2[3], 10) / 255 : 1;
        return [
          [parseInt(c1[0], 10) / 255, parseInt(c1[1], 10) / 255, parseInt(c1[2], 10) / 255, a1],
          [parseInt(c2[0], 10) / 255, parseInt(c2[1], 10) / 255, parseInt(c2[2], 10) / 255, a2]
        ];
      }
    }
    return null;
  }

  var vsSource = [
    'attribute vec4 aVertexPosition;',
    'void main() {',
    '  gl_Position = aVertexPosition;',
    '}'
  ].join('\n');

  var fsSource = [
    'precision highp float;',
    'uniform vec2 iResolution;',
    'uniform float iTime;',
    'uniform vec4 uBgColor1;',
    'uniform vec4 uBgColor2;',
    'uniform vec4 uLineColor;',
    'uniform float uAspectRatio;',
    '',
    'const float overallSpeed = 0.2;',
    'const float gridSmoothWidth = 0.015;',
    'const float axisWidth = 0.05;',
    'const float majorLineWidth = 0.025;',
    'const float minorLineWidth = 0.0125;',
    'const float majorLineFrequency = 5.0;',
    'const float minorLineFrequency = 1.0;',
    'const vec4 gridColor = vec4(0.5);',
    'const float scale = 5.0;',
    'const float minLineWidth = 0.025;',
    'const float maxLineWidth = 0.3;',
    'const float lineSpeed = 1.0 * overallSpeed;',
    'const float lineAmplitude = 1.0;',
    'const float lineFrequency = 0.2;',
    'const float warpSpeed = 0.2 * overallSpeed;',
    'const float warpFrequency = 0.5;',
    'const float warpAmplitude = 1.0;',
    'const float offsetFrequency = 0.5;',
    'const float offsetSpeed = 1.33 * overallSpeed;',
    'const float minOffsetSpread = 0.6;',
    'const float maxOffsetSpread = 2.0;',
    'const int linesPerGroup = 16;',
    '',
    '#define drawCircle(pos, radius, coord) smoothstep(radius + gridSmoothWidth, radius, length(coord - (pos)))',
    '#define drawSmoothLine(pos, halfWidth, t) smoothstep(halfWidth, 0.0, abs(pos - (t)))',
    '#define drawCrispLine(pos, halfWidth, t) smoothstep(halfWidth + gridSmoothWidth, halfWidth, abs(pos - (t)))',
    '#define drawPeriodicLine(freq, width, t) drawCrispLine(freq / 2.0, width, abs(mod(t, freq) - (freq) / 2.0))',
    '',
    'float drawGridLines(float axis) {',
    '  return drawCrispLine(0.0, axisWidth, axis)',
    '         + drawPeriodicLine(majorLineFrequency, majorLineWidth, axis)',
    '         + drawPeriodicLine(minorLineFrequency, minorLineWidth, axis);',
    '}',
    '',
    'float drawGrid(vec2 space) {',
    '  return min(1.0, drawGridLines(space.x) + drawGridLines(space.y));',
    '}',
    '',
    'float random(float t) {',
    '  return (cos(t) + cos(t * 1.3 + 1.3) + cos(t * 1.4 + 1.4)) / 3.0;',
    '}',
    '',
    'float getPlasmaY(float x, float horizontalFade, float offset) {',
    '  return random(x * lineFrequency + iTime * lineSpeed) * horizontalFade * lineAmplitude + offset;',
    '}',
    '',
    'void main() {',
    '  vec2 fragCoord = gl_FragCoord.xy;',
    '  vec4 fragColor;',
    '  vec2 uv = fragCoord.xy / iResolution.xy;',
    '  float scaleBase = max(iResolution.x, iResolution.y * uAspectRatio);',
    '  vec2 space = (fragCoord - iResolution.xy / 2.0) / scaleBase * 2.0 * scale;',
    '',
    '  float rawHFade = 1.0 - (cos(uv.x * 6.28) * 0.5 + 0.5);',
    '  float portraitScale = clamp(1.0 / max(uAspectRatio, 0.2), 1.0, 4.0);',
    '  float horizontalFade = clamp(rawHFade * portraitScale, 0.0, 1.0);',
    '  float verticalFade = 1.0 - (cos(uv.y * 6.28) * 0.5 + 0.5);',
    '',
    '  float dynWarpAmp = warpAmplitude * portraitScale;',
    '  space.y += random(space.x * warpFrequency + iTime * warpSpeed) * dynWarpAmp * (0.5 + horizontalFade);',
    '  space.x += random(space.y * warpFrequency + iTime * warpSpeed + 2.0) * dynWarpAmp * horizontalFade;',
    '',
    '  float dynMinSpread = minOffsetSpread * portraitScale;',
    '  float dynMaxSpread = maxOffsetSpread * portraitScale;',
    '',
    '  vec4 lines = vec4(0.0);',
    '',
    '  for(int l = 0; l < linesPerGroup; l++) {',
    '    float normalizedLineIndex = float(l) / float(linesPerGroup);',
    '    float offsetTime = iTime * offsetSpeed;',
    '    float offsetPosition = float(l) + space.x * offsetFrequency;',
    '    float rand = random(offsetPosition + offsetTime) * 0.5 + 0.5;',
    '    float halfWidth = mix(minLineWidth, maxLineWidth, rand * horizontalFade) / 2.0;',
    '    float offset = random(offsetPosition + offsetTime * (1.0 + normalizedLineIndex)) * mix(dynMinSpread, dynMaxSpread, horizontalFade);',
    '    float linePosition = getPlasmaY(space.x, horizontalFade, offset);',
    '    float line = drawSmoothLine(linePosition, halfWidth, space.y) / 2.0 + drawCrispLine(linePosition, halfWidth * 0.15, space.y);',
    '',
    '    float circleX = mod(float(l) + iTime * lineSpeed, 25.0) - 12.0;',
    '    vec2 circlePosition = vec2(circleX, getPlasmaY(circleX, horizontalFade, offset));',
    '    float circle = drawCircle(circlePosition, 0.01, space) * 4.0;',
    '',
    '    line = line + circle;',
    '    lines += line * uLineColor * rand;',
    '  }',
    '',
    '  fragColor = mix(uBgColor2, uBgColor1, uv.y);',
    '  fragColor += lines * verticalFade;',
    '  fragColor.a = clamp(fragColor.a, 0.0, 1.0);',
    '',
    '  gl_FragColor = fragColor;',
    '}'
  ].join('\n');

  function loadShader(gl, type, source) {
    var shader = gl.createShader(type);
    gl.shaderSource(shader, source);
    gl.compileShader(shader);
    if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
      console.error('Shader compile error:', gl.getShaderInfoLog(shader));
      gl.deleteShader(shader);
      return null;
    }
    return shader;
  }

  function initShaderProgram(gl, vsSrc, fsSrc) {
    var vertexShader = loadShader(gl, gl.VERTEX_SHADER, vsSrc);
    var fragmentShader = loadShader(gl, gl.FRAGMENT_SHADER, fsSrc);
    if (!vertexShader || !fragmentShader) return null;
    var program = gl.createProgram();
    gl.attachShader(program, vertexShader);
    gl.attachShader(program, fragmentShader);
    gl.linkProgram(program);
    if (!gl.getProgramParameter(program, gl.LINK_STATUS)) {
      console.error('Program link error:', gl.getProgramInfoLog(program));
      return null;
    }
    return program;
  }

  class IconicAnimatedBackgroundFirst {
    constructor(container) {
      this.container = container;
      if (this.container.dataset.initialized === 'true') return;
      this.container.dataset.initialized = 'true';
      
      this._shaderCleanup = null;
      this.initialize();
    }

    initialize() {
      this.showSection();
      requestAnimationFrame(() => this.showSection());
      setTimeout(() => this.showSection(), 0);

      const enableShader = this.container.getAttribute('data-enable-shader') !== 'false';
      if (enableShader) {
        setTimeout(() => this.initShaderBackground(), 50);
      }
    }

    showSection() {
      if (this.container && this.container.style) {
        this.container.style.setProperty('display', 'block', 'important');
      }
    }

    initShaderBackground() {
      var root = this.container;
      var canvas = root.querySelector('.iconic-shader-background-canvas');
      if (!canvas) return;

      var gl = canvas.getContext('webgl', { alpha: true, premultipliedAlpha: false }) || 
               canvas.getContext('experimental-webgl', { alpha: true, premultipliedAlpha: false });
      if (!gl) {
        console.warn('iconic-animated-background-first: WebGL not supported.');
        return;
      }

      var program = initShaderProgram(gl, vsSource, fsSource);
      if (!program) return;

      var positionBuffer = gl.createBuffer();
      gl.bindBuffer(gl.ARRAY_BUFFER, positionBuffer);
      gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([
        -1.0, -1.0, 1.0, -1.0, -1.0, 1.0, 1.0, 1.0
      ]), gl.STATIC_DRAW);

      var programInfo = {
        program: program,
        attribLocations: { vertexPosition: gl.getAttribLocation(program, 'aVertexPosition') },
        uniformLocations: {
          resolution: gl.getUniformLocation(program, 'iResolution'),
          time: gl.getUniformLocation(program, 'iTime'),
          bgColor1: gl.getUniformLocation(program, 'uBgColor1'),
          bgColor2: gl.getUniformLocation(program, 'uBgColor2'),
          lineColor: gl.getUniformLocation(program, 'uLineColor'),
          aspectRatio: gl.getUniformLocation(program, 'uAspectRatio')
        }
      };

      var bgColorHex = root.getAttribute('data-background-color') || '#1a1a2e';
      var gradientCss = root.getAttribute('data-background-gradient') || '';
      var waveColorHex = root.getAttribute('data-wave-color') || '#9966cc';

      var startTime = Date.now();
      var animationId = null;

      const resize = () => {
        var wrap = root.querySelector('.iconic-shader-background-canvas-wrap');
        if (!wrap) return;
        var rect = wrap.getBoundingClientRect();
        var dpr = window.devicePixelRatio || 1;
        canvas.width = Math.floor(rect.width * dpr);
        canvas.height = Math.floor(rect.height * dpr);
        canvas.style.width = rect.width + 'px';
        canvas.style.height = rect.height + 'px';
        gl.viewport(0, 0, canvas.width, canvas.height);
      };

      const render = () => {
        if (!canvas.width || !canvas.height) {
          animationId = requestAnimationFrame(render);
          return;
        }
        var currentTime = (Date.now() - startTime) / 1000;
        var bgHex = root.getAttribute('data-background-color') || bgColorHex;
        var gradCss = root.getAttribute('data-background-gradient') || gradientCss;
        var gradientColors = gradCss ? parseGradientToTwoColors(gradCss) : null;
        var bg1 = gradientColors ? gradientColors[0] : parseHexColor(bgHex);
        var bg2 = gradientColors ? gradientColors[1] : parseHexColor(bgHex);
        var lineColor = parseHexColor(root.getAttribute('data-wave-color') || waveColorHex);

        gl.clearColor(0.0, 0.0, 0.0, 0.0);
        gl.clear(gl.COLOR_BUFFER_BIT);
        gl.useProgram(programInfo.program);
        gl.uniform2f(programInfo.uniformLocations.resolution, canvas.width, canvas.height);
        gl.uniform1f(programInfo.uniformLocations.time, currentTime);
        gl.uniform1f(programInfo.uniformLocations.aspectRatio, canvas.width / canvas.height);
        gl.uniform4f(programInfo.uniformLocations.bgColor1, bg1[0], bg1[1], bg1[2], bg1[3]);
        gl.uniform4f(programInfo.uniformLocations.bgColor2, bg2[0], bg2[1], bg2[2], bg2[3]);
        gl.uniform4f(programInfo.uniformLocations.lineColor, lineColor[0], lineColor[1], lineColor[2], lineColor[3]);
        gl.bindBuffer(gl.ARRAY_BUFFER, positionBuffer);
        gl.vertexAttribPointer(programInfo.attribLocations.vertexPosition, 2, gl.FLOAT, false, 0, 0);
        gl.enableVertexAttribArray(programInfo.attribLocations.vertexPosition);
        gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
        animationId = requestAnimationFrame(render);
      };

      resize();
      render();

      var resizeObserver = typeof ResizeObserver !== 'undefined'
        ? new ResizeObserver(resize)
        : null;
      if (resizeObserver) {
        var wrap = root.querySelector('.iconic-shader-background-canvas-wrap');
        if (wrap) resizeObserver.observe(wrap);
      }
      window.addEventListener('resize', resize);

      var wrapEl = root.querySelector('.iconic-shader-background-canvas-wrap');
      this._shaderCleanup = () => {
        if (animationId) cancelAnimationFrame(animationId);
        window.removeEventListener('resize', resize);
        if (resizeObserver && wrapEl) resizeObserver.unobserve(wrapEl);
      };
    }
    
    destroy() {
      if (this._shaderCleanup) this._shaderCleanup();
    }
  }

  function initializeBackgrounds() {
    document.querySelectorAll("iconic-animated-background-first").forEach((container) => {
      if (!container.iconicInstance) {
         container.iconicInstance = new IconicAnimatedBackgroundFirst(container);
      }
    });
  }

  document.addEventListener("DOMContentLoaded", initializeBackgrounds);
  
  if (typeof window.Shopify !== 'undefined' && window.Shopify.designMode) {
    initializeBackgrounds();
  }
  
  document.addEventListener("shopify:section:load", initializeBackgrounds);
  document.addEventListener("shopify:section:select", initializeBackgrounds);
  document.addEventListener("shopify:section:unload", (event) => {
    const section = event.target;
    if(section) {
      const container = section.querySelector("iconic-animated-background-first");
      if (container && container.iconicInstance) {
        container.iconicInstance.destroy();
      }
    }
  });

})();